<div class="container mt-5">
  <!-- Betöltés közben -->
  <div *ngIf="loading" class="career-loader text-center my-5">
    <div class="spinner-border text-danger" role="status" aria-hidden="true"></div>
    <p class="mt-3 mb-0">Álláshirdetés betöltése...</p>
  </div>

  <!-- Tartalom betöltés után -->
  <div *ngIf="!loading">
    <div *ngIf="!job" class="text-center my-5">
      <h1>Az állásajánlat nem található!</h1>
    </div>

    <div *ngIf="job" class="card mb-3 shadow-lg p-3 mb-5 bg-white rounded">
      <div class="card-body">
        <!-- Cím + Jelentkezés gomb egy sorban -->
        <div class="d-flex flex-column flex-sm-row align-items-center mb-4">
          <h1 class="me-auto mb-0">{{ job.title }}</h1>
          <span class="d-flex col-12 col-sm-auto align-items-center gap-2">
            <a href="/allasok" class="btn btn-secondary rounded-0 me-2">
              Vissza
            </a>
            <a
              [href]="job.public_link"
              target="_blank"
              rel="noopener"
              class="btn btn-success rounded-0"
            >
              Jelentkezés
            </a>
          </span>
        </div>

        <!-- Cimkék (workfields, employment, city, education) -->
        <div class="mb-4">
          <span class="career-badge me-1" *ngFor="let wf of job.workfields">
            <img
              [src]="getIconPath('workfields')"
              alt=""
              class="career-badge-icon"
            />
            <strong>{{ wf.name }}</strong>
          </span>
          <span class="career-badge me-1" *ngIf="job.employment?.[0]?.name">
            <img
              [src]="getIconPath('employment')"
              alt=""
              class="career-badge-icon"
            />
            <strong>{{ job.employment[0].name }}</strong>
          </span>
          <span class="career-badge me-1" *ngIf="job.addresses?.[0]?.city">
            <img [src]="getIconPath('city')" alt="" class="career-badge-icon" />
            <strong>{{ job.addresses[0].city }}</strong>
          </span>
          <span class="career-badge me-1" *ngIf="job.education?.name">
            <img
              [src]="getIconPath('education')"
              alt=""
              class="career-badge-icon"
            />
            <strong>{{ job.education?.name }}</strong>
          </span>
        </div>

        <!-- Teljes leírás -->
        <div class="job-description" [innerHTML]="job.description"></div>
        <div class="d-flex align-items-center mb-4">
          <span class="me-auto mb-0"></span>
          <span class="d-flex col-12 col-sm-auto align-items-center gap-2">
            <a href="/allasok" class="btn btn-secondary rounded-0 me-2">
              Vissza
            </a>
            <a
              [href]="job.public_link"
              target="_blank"
              rel="noopener"
              class="btn btn-success rounded-0"
            >
              Jelentkezés
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
